import slugify from "slugify";

export function createSlug(text: string): string {
	// Remove translation of these special characters
	slugify.extend({ $: undefined, "&": undefined, "%": undefined });

	// Convert to lower case string and
	// remove special characters and the ones on the remove regexp attribute
	return slugify(text, {
		lower: true,
		strict: true,
		remove: /[:~!@#$%^&*()+\\§_]/gmu,
	}).trim();
}
